import { render, staticRenderFns } from "./fxRates.vue?vue&type=template&id=23fb497e"
import script from "./fxRates.vue?vue&type=script&lang=js"
export * from "./fxRates.vue?vue&type=script&lang=js"
import style0 from "./fxRates.vue?vue&type=style&index=0&id=23fb497e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports